import { QUESTIONNAIRE_EVALUATION_INITIALIZATION_POST_REQUEST, QUESTIONNAIRE_EVALUATION_INITIALIZATION_POST_SUCCESS, QUESTIONNAIRE_EVALUATION_FAILURE, QUESTIONNAIRE_EVALUATION_QUESTION_GET_REQUEST, QUESTIONNAIRE_EVALUATION_SAVE_REQUEST, QUESTIONNAIRE_EVALUATION_QUESTION_GET_SUCCESS } from "../../../domain/questionnaireEvaluation";
import { PHOTO_CAPTURE_ATTACHMENT_REQUEST, PHOTO_CAPTURE_GET_AUTHENTICATION_DATA_REQUEST, PHOTO_CAPTURE_GET_CONTEXT_DATA_REQUEST, PHOTO_CAPTURE_GET_CONTEXT_DATA_SUCCESS, PHOTO_CAPTURE_GET_DATA_FAILURE, PHOTO_CAPTURE_UPDATE_CONTEXT_DATA_REQUEST, PHOTO_CAPTURE_FILE_UPLOAD_FAILED, PHOTO_CAPTURE_INVALID_FILE_UPLOAD, PHOTO_CAPTURE_GET_FRAUD_WARNING_DATA_REQUEST, PHOTO_CAPTURE_GET_FRAUD_WARNING_DATA_SUCCESS, VIN_INVALID_MESSAGE, INTELLIGENT_PHOTO_CAPTURE_SAVE_CAPTURED_PHOTO, INTELLIGENT_PHOTO_CAPTURE_FILE_DOWNLOAD_START, INTELLIGENT_PHOTO_CAPTURE_FILE_DOWNLOAD_COMPLETE, PHOTO_CAPTURE_INTELLIGENT_IMAGE_DETAIL_OCR_REQUEST, PHOTO_CAPTURE_INTELLIGENT_IMAGE_DETAIL_OCR_SUCCESS, PHOTO_CAPTURE_INTELLIGENT_RESET_IMAGE_ANALYZER_DETAILS, PHOTO_CAPTURE_INTELLIGENT_IMAGE_DETAILS_SUCCESS, PHOTO_CAPTURE_INTELLIGENT_IMAGE_DETAILS_FAILURE, PHOTO_CAPTURE_INTELLIGENT_IMAGE_DETAIL_OCR_FAILURE } from "../../../domain/photoCapture";
import { FILE_UPLOAD_ALL_FILES_UPLOAD_START, FILE_UPLOAD_SINGLE_FILE_UPLOAD_START, FILE_UPLOAD_ADD_SINGLE_FILE, FILE_UPLOAD_SINGLE_FILE_UPLOAD_COMPLETE, FILE_UPLOAD_SINGLE_FILE_UPLOAD_CANCEL } from "../../../domain/file";
import { BRANDED_NOTIFICATION_GET_CONFIGURATION_DATA_SUCCESS, BRANDED_NOTIFICATION_GET_CONFIGURATION_DATA_FAILURE, BRANDED_NOTIFICATION_GET_CONFIGURATION_DATA } from "../../../domain/brandedNotification";
import { ON_INVALID_VIN_DATA, ON_VALID_VIN_DATA, ON_RESET_VEHICLE_INFO, ON_VEHICLE_INFO_UPDATED, ON_VEHICLE_IDENTIFICATION_ERROR_UPDATE, FLYOUT_CLICKED, ON_VSS_ERROR_UPDATE, VehicleIdentificationErrorCode } from "../../../domain/vehicleInfo";
import { VEHICLE_CONFIGURATION_ATTRIBUTES_GET_FAILURE, VEHICLE_CONFIGURATION_ATTRIBUTES_GET_SUCCESS } from "../../../domain/vehicleConfigurationAttributes";
import { GPCConstant as initialState, PHOTO_CAPTURE_DEFAULT_ERRORCODE, PHOTO_CAPTURE_VIN_DECODE_NETWORK_ERRORCODE } from '../constants';
import { gpcAppContentReducer } from './gpcAppContentReducer';
export const gpcRootReducer = (state = initialState, action) => {
    switch (action.type) {
        case PHOTO_CAPTURE_GET_AUTHENTICATION_DATA_REQUEST:
        case PHOTO_CAPTURE_GET_CONTEXT_DATA_REQUEST:
        case PHOTO_CAPTURE_UPDATE_CONTEXT_DATA_REQUEST:
        case QUESTIONNAIRE_EVALUATION_INITIALIZATION_POST_REQUEST:
        case QUESTIONNAIRE_EVALUATION_QUESTION_GET_REQUEST:
        case QUESTIONNAIRE_EVALUATION_SAVE_REQUEST:
        case FILE_UPLOAD_ALL_FILES_UPLOAD_START:
        case FILE_UPLOAD_SINGLE_FILE_UPLOAD_START:
        case FILE_UPLOAD_ADD_SINGLE_FILE:
        case PHOTO_CAPTURE_GET_FRAUD_WARNING_DATA_REQUEST:
        case FLYOUT_CLICKED:
        case BRANDED_NOTIFICATION_GET_CONFIGURATION_DATA:
        case PHOTO_CAPTURE_INTELLIGENT_IMAGE_DETAIL_OCR_REQUEST:
        case INTELLIGENT_PHOTO_CAPTURE_FILE_DOWNLOAD_START:
            return Object.assign(Object.assign({}, state), { isLoading: true, isErrorOccured: false });
        case PHOTO_CAPTURE_ATTACHMENT_REQUEST:
            return Object.assign(Object.assign({}, state), { isLoading: true });
        case PHOTO_CAPTURE_INTELLIGENT_RESET_IMAGE_ANALYZER_DETAILS:
            return Object.assign(Object.assign({}, state), { isLoading: !action.payload.shouldDisplayIQAScreen, isErrorOccured: false });
        case PHOTO_CAPTURE_INTELLIGENT_IMAGE_DETAIL_OCR_SUCCESS:
            return Object.assign(Object.assign({}, state), { isLoading: false, isErrorOccured: false });
        case QUESTIONNAIRE_EVALUATION_INITIALIZATION_POST_SUCCESS:
        case QUESTIONNAIRE_EVALUATION_QUESTION_GET_SUCCESS:
        case PHOTO_CAPTURE_GET_CONTEXT_DATA_SUCCESS:
        case FILE_UPLOAD_SINGLE_FILE_UPLOAD_COMPLETE:
        case FILE_UPLOAD_SINGLE_FILE_UPLOAD_CANCEL:
        case FILE_UPLOAD_ADD_SINGLE_FILE:
        case PHOTO_CAPTURE_GET_FRAUD_WARNING_DATA_SUCCESS:
        case ON_VEHICLE_INFO_UPDATED:
        case PHOTO_CAPTURE_INTELLIGENT_IMAGE_DETAILS_SUCCESS:
        case PHOTO_CAPTURE_INTELLIGENT_IMAGE_DETAILS_FAILURE:
        case PHOTO_CAPTURE_INTELLIGENT_IMAGE_DETAIL_OCR_FAILURE:
        case INTELLIGENT_PHOTO_CAPTURE_FILE_DOWNLOAD_COMPLETE:
            return Object.assign(Object.assign({}, state), { isLoading: false, isErrorOccured: false });
        case BRANDED_NOTIFICATION_GET_CONFIGURATION_DATA_SUCCESS:
            const { brandedNotificationConfigurationData } = action.payload;
            return Object.assign(Object.assign({}, state), { isLoading: false, isErrorOccured: false, styleData: brandedNotificationConfigurationData.styleData && brandedNotificationConfigurationData.styleData.profileData
                    ? Object.assign(Object.assign({}, state.styleData), JSON.parse(brandedNotificationConfigurationData.styleData.profileData)) : state.styleData, contentData: gpcAppContentReducer(state, action) });
        case QUESTIONNAIRE_EVALUATION_FAILURE:
        case PHOTO_CAPTURE_GET_DATA_FAILURE:
        case BRANDED_NOTIFICATION_GET_CONFIGURATION_DATA_FAILURE:
        case PHOTO_CAPTURE_FILE_UPLOAD_FAILED:
            return Object.assign(Object.assign({}, state), { isLoading: false, isErrorOccured: true });
        case PHOTO_CAPTURE_INVALID_FILE_UPLOAD:
            return Object.assign(Object.assign({}, state), { intelligentFileUploadErrorInfo: action.payload.errorData, isLoading: false, isErrorOccured: true });
        case ON_VEHICLE_IDENTIFICATION_ERROR_UPDATE:
            return Object.assign(Object.assign({}, state), { isLoading: false, errorState: {
                    error: '',
                    errorCode: action.payload.errorCode === VehicleIdentificationErrorCode.VinDecodeFailure
                        ? PHOTO_CAPTURE_VIN_DECODE_NETWORK_ERRORCODE
                        : 0
                } });
        case ON_VALID_VIN_DATA:
            return Object.assign(Object.assign({}, state), { isLoading: true, isErrorOccured: false, errorState: {
                    error: '',
                    errorCode: 0
                } });
        case ON_RESET_VEHICLE_INFO:
        case VEHICLE_CONFIGURATION_ATTRIBUTES_GET_SUCCESS:
            return Object.assign(Object.assign({}, state), { isLoading: false, isErrorOccured: false, errorState: {
                    error: '',
                    errorCode: 0
                } });
        case ON_INVALID_VIN_DATA:
            return Object.assign(Object.assign({}, state), { errorState: {
                    error: VIN_INVALID_MESSAGE,
                    errorCode: PHOTO_CAPTURE_DEFAULT_ERRORCODE
                } });
        case ON_VSS_ERROR_UPDATE:
            const { error, errorCode } = action.payload.errorPayload;
            return Object.assign(Object.assign({}, state), { isLoading: false, isErrorOccured: true, errorState: {
                    error: error,
                    errorCode: errorCode
                } });
        case VEHICLE_CONFIGURATION_ATTRIBUTES_GET_FAILURE:
            return Object.assign(Object.assign({}, state), { isLoading: false, isErrorOccured: true });
        case INTELLIGENT_PHOTO_CAPTURE_SAVE_CAPTURED_PHOTO: {
            return Object.assign(Object.assign({}, state), { isErrorOccured: false });
        }
        default:
            return Object.assign({}, state);
    }
};
//# sourceMappingURL=gpcRootReducer.js.map